import { useLocation } from 'react-router-dom';

function useQuery(): any {
  return new URLSearchParams(useLocation().search);
}

export default useQuery;
